const titleCase = (string) => {
  if (string !== undefined) {
    return string
      .replace(/\s+/g, ' ')
      .trim()
      .split(' ')
      .map((word) => {
        word = word.toLowerCase();
        return word[0].toUpperCase() + word.slice(1);
      })
      .join(' ');
  } 
  return "";
};

export default titleCase;
